"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETH_SYMBOL = exports.ETH_NAME = void 0;
const types_1 = require("./types");
exports.ETH_NAME = {
    [types_1.Networks.Ropsten]: 'Ethereum',
    [types_1.Networks.Mainnet]: 'Ethereum',
    [types_1.Networks.Polygon]: 'Polygon',
    [types_1.Networks.Arbitrum]: 'Ethereum',
    [types_1.Networks.Avalanche]: 'Avalanche',
    [types_1.Networks.Moonriver]: 'Moonriver',
    [types_1.Networks.Aurora]: 'Ethereum',
    [types_1.Networks.Cronos]: 'Crypto.com',
    [types_1.Networks.Fantom]: 'Fantom',
    [types_1.Networks.Harmony]: 'Harmony',
    [types_1.Networks.Moonbeam]: 'Moonbeam',
    [types_1.Networks.Sxnetwork]: 'SX Network',
    [types_1.Networks.Canto]: 'CANTO',
    [types_1.Networks.ZksyncEra]: 'Ethereum',
    [types_1.Networks.Blast]: 'Ethereum',
    [types_1.Networks.Base]: 'Ethereum',
    [types_1.Networks.Mantle]: 'Mantle',
    [types_1.Networks.Scroll]: 'Ethereum',
    [types_1.Networks.Optimism]: 'Ethereum',
    [types_1.Networks.Real]: 'Ethereum',
    [types_1.Networks.Sonic]: 'S',
    [types_1.Networks.Linea]: 'Ethereum',
};
exports.ETH_SYMBOL = {
    [types_1.Networks.Ropsten]: 'ETH',
    [types_1.Networks.Mainnet]: 'ETH',
    [types_1.Networks.Polygon]: 'MATIC',
    [types_1.Networks.Arbitrum]: 'ETH',
    [types_1.Networks.Avalanche]: 'AVAX',
    [types_1.Networks.Moonriver]: 'MOVR',
    [types_1.Networks.Aurora]: 'ETH',
    [types_1.Networks.Cronos]: 'CRO',
    [types_1.Networks.Fantom]: 'FTM',
    [types_1.Networks.Harmony]: 'ONE',
    [types_1.Networks.Moonbeam]: 'GLMR',
    [types_1.Networks.Sxnetwork]: 'SX',
    [types_1.Networks.Canto]: 'CANTO',
    [types_1.Networks.ZksyncEra]: 'ETH',
    [types_1.Networks.Blast]: 'ETH',
    [types_1.Networks.Base]: 'ETH',
    [types_1.Networks.Mantle]: 'MNT',
    [types_1.Networks.Scroll]: 'ETH',
    [types_1.Networks.Optimism]: 'ETH',
    [types_1.Networks.Real]: 'reETH',
    [types_1.Networks.Sonic]: 'S',
    [types_1.Networks.Linea]: 'ETH',
};
